import { computed, signal } from '@angular/core';
import { noGroup } from '@core/helpers';

export class AppRoutes {
    private static groupId = signal<number>(noGroup.id);
    static computedGroupId = AppRoutes.groupId.asReadonly();

    static updateGroupId(id: number) {
        AppRoutes.groupId.set(id);
    }

    static get seqGroupId(): number {
        return AppRoutes.groupId();
    }

    static routes = computed(() => {
        return {
            ERROR: `/${AppRoutes.groupId()}/error`,
            NOT_FOUND: `/${AppRoutes.groupId()}/not-found`,
            FORBIDDEN: `/${AppRoutes.groupId()}/forbidden-access`,

            DASHBOARD: `/${AppRoutes.groupId()}/${AppRoutes.routesSegments.DASHBOARD}`,

            ORDERS_REACTIONS_LIST: `/${AppRoutes.groupId()}/orders/list/reactions`,
            ORDERS_LIST: `/${AppRoutes.groupId()}/orders/list`,
            ORDERS_DRAFT: (id?: number) => `/${AppRoutes.groupId()}/orders/setup/${id}`,
            ORDERS_SETUP: `/${AppRoutes.groupId()}/orders/setup`,

            ORDERS_ABSTRACT_DETAILS: (id: number) => `/${AppRoutes.groupId()}/orders/details/${id}`,
            ORDERS_ABSTRACT_RESULTS: (id: number) => `/${AppRoutes.groupId()}/orders/details/${id}/results`,
            ORDERS_ABSTRACT_BASE_URL: `/${AppRoutes.groupId()}/orders/details`,

            ORDERS_CHECKMATE_RETEST_LIST: `/${AppRoutes.groupId()}/checkmate/list`,
            ORDERS_CHECKMATE_RETEST_SETUP: `/${AppRoutes.groupId()}/checkmate/retest`,

            INVENTORY_PRIMERS: `/${AppRoutes.groupId()}/inventory/list/primers`,
            INVENTORY_SAMPLES: `/${AppRoutes.groupId()}/inventory/list/samples`,
            INVENTORY_BASE_URL: `/${AppRoutes.groupId()}/inventory`,

            GROUP_SETTINGS_MEMBERS: (id: number) => `/${AppRoutes.groupId()}/groups/settings/${id}/members`,
            GROUP_SETTINGS_PRICING: (id: number) => `/${AppRoutes.groupId()}/groups/settings/${id}/pricing`,
            GROUP_SETTINGS_GENERAL: (id: number) => `/${AppRoutes.groupId()}/groups/settings/${id}`,
            GROUP_SETTINGS_BASE_URL: `/${AppRoutes.groupId()}/groups/settings`,
            GROUPS_LISTING: `/${AppRoutes.groupId()}/groups`,
        };
    });

    static routesSegments = {
        DASHBOARD: 'dashboard',
    };
}
